import * as React from 'react';
import * as styles from './build-segment.module.scss';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { TertiaryButton, SecondaryButton } from 'kagr-ui';

interface Props {
  open: boolean;
  title: string;
  children: React.ReactNode;
  applyDisabled?: boolean;
  handleCancel: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleApply: (event?: Event) => void;
}

const useStyles = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.up('sm')]: {
      '& .MuiDialog-paperWidthSm': {
        maxWidth: '640px'
      }
    }
  },
  dialogActions: {
    justifyContent: 'space-between',
    height: 57,
    padding: '0 24px'
  }
}));

/**
 * Dialog menu for use in attribute filtering for menus not requiring a search bar (range and datetime).
 */
const AttributeFilterDialog = ({ open, title, children, applyDisabled = false, handleCancel, handleApply }: Props) => {
  const overrides = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.only('xs'));

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      scroll="paper"
      fullScreen={fullScreen}
      className={overrides.dialog}
      aria-labelledby="select-attribute-dialog-title"
    >
      <DialogTitle id="select-attribute-dialog-title" disableTypography>
        <h3 className={styles.dialogTitle}>{title}</h3>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions className={overrides.dialogActions}>
        <TertiaryButton text="Cancel" title="Cancel" component="button" handleClick={handleCancel} />
        <SecondaryButton text="Apply" title="Apply" handleClick={handleApply} deactive={applyDisabled} />
      </DialogActions>
    </Dialog>
  );
};

export default AttributeFilterDialog;
